import { render } from "./PopupBtnList.vue?vue&type=template&id=46f6558f&scoped=true"
import script from "./PopupBtnList.vue?vue&type=script&lang=js"
export * from "./PopupBtnList.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=46f6558f&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f6558f"]])

export default __exports__